<template>
  <div class="vedioList">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>在线课程</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>在线课程</h3>
    </div>
    <div class="content" v-if="isCourseInfo">
      <el-card class="box-card" style="width:100%">
        <div
          slot="header"
          class="clearfix"
        >
          <div style="display:flex;justify-content: space-between;">
           <div style="flex:1">
              <div class="courseImg"></div>
            <strong>课程名称: {{courseInfo.courseName}}
             
            </strong>
            <span style="display:block">课程分类: {{courseInfo.sortingClass}} </span>
            
           </div>
           
            <router-link :to="{path: '/online', query: {menuId: menuId}}">
              <el-button style="float:right">
                返回列表
              </el-button>
            </router-link>
            <!-- <el-button style="float:right">立即参加</el-button> -->
            <!-- <el-button
              v-if="isShowAddBtn"
              type="primary"
              style="float:right"
              @click="addVedio"
            >添加视频</el-button> -->
            <!-- <el-button
              type="primary"
              style="float:right"
              @click="addVedio"
            >添加视频</el-button> -->
          </div>
        </div>
        <div style="font-size:14px;width:100%;display: flex;">
          <!-- <div style="overflow:hidden;width:100%"> -->
            <!-- <div style="width:49%;height:60px;float:left;">
              讲者: &emsp;{{courseInfo.lecture.value}}
            </div> -->
            <!-- <div style="width:50%;height:60px;float:left;">
              发布人: &emsp;{{courseInfo.release['value']}}
            </div> -->
          <!-- </div> -->
         

          <div style="overflow:hidden;width:100%;flex: 3;padding-right:10px">
           <div style="position:relative;">
             <!-- <video controls style="width:100%; height: 600px;object-fit: cover;"  :src="baseUrl + courseInfo.videosFileUrl"></video> -->
             <Video :srcs="baseUrl + courseInfo.videosFileUrl" style="width:100%"></Video>
           </div>
            <div style="width:49%;height:60px;float:left;">
              发布人: &emsp;{{courseInfo.release.value}}
            </div>
            <div style="width:50%;height:60px;float:left;">
              发布时间: &emsp;{{ courseInfo.createTime }}
            </div>
          </div>
          <div style="flex:1;border-left: 1px solid #ccc;padding-left:10px">
            <h3>课程描述:</h3> {{courseInfo.describe}}
          </div>
        </div>
      </el-card>
      <!-- 详情 / 目录 tab切换 -->
     
    </div>
    <!-- 上传视频模态框 -->
  
    
  </div>
</template>

<script>
import moment from "moment";
import Editor from "./editor";
import Video from "./video.vue"
export default {
  components: {
    Editor,
    Video
  },
  watch: {
    videoId: function(val) {
      if (val !== this.value) {
        this.$emit("input", val);
      }
    }
  },
  data() {
    return {
      baseUrl: 'http://192.168.199.122:5010/', //图片封面地址
      isShowAddBtn: true,
      activeName: "first",
      uploadDialog: false,
      modlaName: "",
      courseId: this.$route.query.courseId,
      menuId: this.$route.query.menuId,
      courseInfo: [],
      isCourseInfo: false, // courseInfo数据是否获取完成
      tableData: [
        {
          name: "名称",
          date: "2019-01-10"
        }
      ],
      ruleForm: {
        title: "",
        lecture: ""
      },
      timeout: '',
      partSize: '',
      parallel: '',
      retryCount: '',
      retryDuration: '',
      region: 'cn-shanghai',
      userId: '1044339376989360',
      file: null,
      authProgress: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      uploader: null,
      statusText: '',
      userId: localStorage.getItem('UserId'),
      fileName: '',
      fileList: [],
      videoList: [],  //视频列表
      coverUrl: ''  //封面图片地址
    };
  },
  created() {
    // console.log(this.$route.query.courseId)
    this.getCourseInfo();
  },
  mounted() {
    document.onkeydown = (e) => {
    if (window.event && window.event.keyCode == 123) {
        return false;
      //禁用ctrl+shift+i,
      }
    }
  },
  methods: {
    
    close() {
      if (this.uploader !== null) {
        this.fileName = ''
        this.uploader.cleanList();
        this.uploadDisabled = true
        $('#file').val('')
      }
    },
    // 查询视频信息
    getCourseInfo() {
      const _this = this;
      this.Axios.get(
        "/api/Education/GetEducationInfo?id=" + this.courseId
      ).then(res => {
        const data = res.data;
        if (data.status === 100) {
          this.courseInfo = data.data;
          this.courseInfo.createTime = moment(
            this.courseInfo.createTime
          ).format("YYYY-MM-DD HH:mm");
          // console.log('课程信息', this.courseInfo)
          for (let vItme of this.courseInfo.videos) {
            vItme.updateTime = moment(
              vItme.updateTime
            ).format("YYYY-MM-DD HH:mm");
          }
          // this.videoList = this.courseInfo.videos
          this.videoList = [this.courseInfo]
          // this.videoList = Object.values(data.data)
          data.data.release.key == this.userId ? this.isShowAddBtn = true : this.isShowAddBtn = false
          this.isCourseInfo = true
          // courseItem.release.key == userId
          // console.log()
        } else {
          this.$message({
            showClose: true,
            message: "网络错误,请联系管理员!",
            type: "success"
          });
        }
      });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleClick(tab, event) {
      // console.log(tab.label);
    },
    // 播放视频
    study(val) {
      // console.log('val', val)
      this.Axios.get('/api/Education/GetVideoPath?id=' + this.courseId +'&vid=' + val.vid).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          // console.log(222, data.data)
          this.$router.push({
            name:"vedioplay",
            query:{
              url: data.data[0],
              courseId: this.courseId,
              name: val.vName
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: '获取视频地址失败,请重试!',
            type: 'error'
          })
        }
      })

    },
    edit(val) {},
    del(val) {
      this.Axios.delete('/api/Education/DeleteVideoFile?id=' + this.courseId +'&vid=' + val.vid).then(res => {
        // console.log(res.data)
        const data = res.data
        if (data.status === 100) {
          this.$message({
            showClose: true,
            message: '视频删除成功!',
            type: 'success'
          })
          this.getCourseInfo()
        } else {
          this.$message({
            showClose: true,
            message: '视频删除失败,请重试!',
            type: 'error'
          })
        }
      })
    },
    // 点击添加视频按钮
    addVedio() {
      this.uploadDialog = true;
      this.modlaName = "添加课程";
    },
    uploadVedio() {
      this.Axios.put(
        "/api/Education/UploadVideoFile?id=" +
          this.courseId +
          "&title=光年之外" +
          "&fileName=" +
          this.file.name
      ).then(res => {
        const data = res.data;
        if (data.status == 100) {
          const info = data.data;
        }
      });
    },

    fileChange (e) {
      this.file = e.target.files[0]
      if (!this.file) {
        alert("请先选择需要上传的文件!")
        return
      }
      this.fileName = this.file.name
      var Title = this.file.name
      var userData = '{"Vod":{}}'
      if (this.uploader) {
        this.uploader.stopUpload()
        this.authProgress = 0
        this.statusText = ""
      }
      this.uploader = this.createUploader()
      // console.log(userData)
      this.uploader.addFile(this.file, null, null, null, userData)
      this.fileList = this.uploader.listFiles() //待上传的文件列表
      this.uploadDisabled = false
      this.pauseDisabled = true
      this.resumeDisabled = true
    },

    createUploader (type) {
      let self = this
      let uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: self.partSize || 1048576,
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          self.uploadDisabled = false
          self.resumeDisabled = false
          self.statusText = '添加文件成功, 等待上传...'
          // console.log("addFileSuccess: " + uploadInfo.file.name)
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
          // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
          // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
          // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
          // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
          // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
          // console.log('uploadInfo', uploadInfo)
          if (!uploadInfo.videoId) {
            // let createUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateUploadVideo?Title=testvod1&FileName=aa.mp4&BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&VideoId=5bfcc7864fc14b96972842172207c9e6'
            let createUrl = "/api/Education/UploadVideoFile?id=" + self.courseId + "&title=" + self.ruleForm.title + "&lecture=" + self.ruleForm.lecture  + "&fileName=" + self.fileName
            self.Axios.put(createUrl).then(({data}) => {
              const info = data.data
              let uploadAuth = info.uploadAuth
              let uploadAddress = info.uploadAddress
              let videoId = info.videoId
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            })
            self.statusText = '文件开始上传...'
            // console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
          } else {
            // 如果videoId有值，根据videoId刷新上传凭证
            // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
            // let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            // axios.get(refreshUrl).then(({data}) => {
            //   let uploadAuth = data.UploadAuth
            //   let uploadAddress = data.UploadAddress
            //   let videoId = data.VideoId
            //   uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            // })

            let createUrl = "/api/Education/UploadVideoFile?id=" + self.courseId + "&title=" + self.ruleForm.title + "&lecture=" + self.ruleForm.lecture  + "&fileName="  + self.fileName
            self.Axios.put(createUrl).then(({data}) => {
              const info = data.data
              let uploadAuth = info.uploadAuth
              let uploadAddress = info.uploadAddress
              let videoId = info.videoId
              uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
            })
            self.statusText = '文件开始上传...'
            // console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
          }
        },
        // 文件上传成功
        onUploadSucceed: function (uploadInfo) {
          // console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
          // self.statusText = '文件上传成功!'
          // console.log('上传成功', uploadInfo)
          self.Axios.get('/api/Education/UploadSuccess?id=' + self.courseId + '&vid=' + uploadInfo.videoId).then(res => {
            // console.log(res.data)
          })
          if (self.uploader !== null) {
            self.fileName = ''
            self.uploader.cleanList();
            self.uploadDisabled = false
            $('#file').val('')
          }
          self.ruleForm.title = ''
          self.ruleForm.lecture = ''
          self.$message({
            showClose: true,
            message: '文件上传成功!',
            type: 'success'
          })
          self.uploadDialog = false
          let t1 = setTimeout(() => {
            self.getCourseInfo()
            clearTimeout(t1)
          }, 1000)
          self.authProgress = 0
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          // console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
          self.statusText = '文件上传失败!'
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          // console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
          self.statusText = '文件已暂停上传'
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          // console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
          let progressPercent = Math.ceil(progress * 100)
          self.authProgress = progressPercent
          self.statusText = '文件上传中...'
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
          // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
          // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
          let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
          axios.get(refreshUrl).then(({data}) => {
            let uploadAuth = data.UploadAuth
            uploader.resumeUploadWithAuth(uploadAuth)
            // console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
          })
          self.statusText = '文件超时...'
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          // console.log("onUploadEnd: uploaded all the files")
          self.statusText = '文件上传完毕'
        }
      })
      return uploader
    },

    // 暂停上传
    // pauseUpload () {
    //   if (this.uploader !== null) {
    //     this.uploader.stopUpload()
    //     this.resumeDisabled = false
    //     this.pauseDisabled = true
    //   }
    // },
    // // 恢复上传
    // resumeUpload () {
    //   if (this.uploader !== null) {
    //     this.uploader.startUpload()
    //     this.resumeDisabled = true
    //     this.pauseDisabled = false
    //   }
    // },
    // 取消上传
    cancelUpload() {
      // console.log('取消上传')
      // if (this.uploader !== null) {
      //   // this.uploader.startUpload()
      //   this.uploadDialog = false
      //   // this.uploader.cancelFile(0);
      // }
      this.uploadDialog = false
    },
    // 开始上传视频
    doUploadVedio() {
      if (this.uploader !== null) {
        if (this.fileList.length <= 0) {
          this.$message({
            showClose: true,
            message: '请选择上传文件!',
            type: 'error'
          })
        } else if (this.ruleForm.title == '') {
          this.$message({
            showClose: true,
            message: '请输入视频名!',
            type: 'error'
          })
          return
        } else {
          this.uploader.startUpload()
          this.uploadDisabled = true
          this.pauseDisabled = false
        }
      }
    }


  }
};
</script>

<style lang="less">
.vedioList {
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .content {
    padding: 20px;
    .courseImg {
      float: left;
      width: 28px;
      height: 28px;
      background: url("../../assets/u1938.png") no-repeat;
      background-size: 95% 95%;
      position: relative;
      top: -2px;
      margin-right: 12px;
    }
    .el-tabs__nav-scroll {
      padding-left: 30px;
      background: #e4e7ed;
      // margin-top: 25px;
    }
  }
  .el-input__inner {
    width: 360px;
  }
  /deep/ .el-icon-upload {
    font-size: 50px;
    color: #c0c4cc;
  }
  .fileList {
    border-bottom:1px solid #ebeef5;
    width:360px;
    font-size:12px;
    height:30px;
    line-height:30px;
    padding-left:4px;
    position: relative;
  }
  .close {
    position: absolute;
    right: 5px;
  }
  .file {
    width:150px;
    height:150px;
    border:1px dashed #d9d9d9;
    text-align:center;
    line-height:150px;
    border-radius: 6px;
    cursor:pointer
    // &:focus {
    //   border-color:  #409eff;

    //   cursor:pointer
    // }
  }
  // style=""
  .watermark {
    position: absolute;
    right: 0;
    top: 0;
    color: white;
    opacity: 0.6;
    font-size: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/RemoteMedical/VedioList.vue